import React from 'react';
import { Badge } from 'spa/member/components/Badge';
import { LabelProps } from './types';

export const StyledLabel: React.FC<LabelProps> = ({
  className,
  badge,
  htmlFor,
  label,
  ...rest
}: LabelProps) => {
  const renderBadge = () => {
    if (badge === undefined) return null;

    const badgeKind = badge === 'REQUIRED' ? 'danger' : 'gray';
    const badgeText = badge === 'REQUIRED' ? '必須' : '任意';

    return (
      <div className="flex items-center h-6 mr-2">
        <Badge badgeType="small" kind={badgeKind} style={{ marginTop: '1px' }}>
          {badgeText}
        </Badge>
      </div>
    );
  };

  return (
    <div className={`flex mb-XS ${className || ''}`}>
      {renderBadge()}
      <div className="flex flex-col">
        <label
          htmlFor={htmlFor}
          className="text-member-gray-100 text-XS leading-normal m-0 items-center"
          style={{ letterSpacing: '.02em' }}
          {...rest}
        >
          {label}
        </label>
      </div>
    </div>
  );
};
